import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ITrajectoryDetail,
  PageType,
  TrajectorySectionCode,
  trajectorySectionCodeLookup,
} from '../../../../../config/api/models/Trajectory';
import { TabbedContent } from '../../../../shared/components';
import { useAppDispatch } from 'src/modules/shared/hooks/useAppDispatch';
import {
  setConfirmationTrajectory,
  setOpenConfirmPublishDraft,
  setOpenConfirmUnPublishDraft,
} from 'src/modules/shared/slices/trajectories/entity/trajectorySlice';
import { PageManagementSidebarContentNew } from './page-management/PageManagementSidebarContentNew';
import { TrajectoryPublishSidebar } from './TrajectoryPublishSidebar';
import { PageManagementSidebarContent } from './page-management';
import { useUser } from 'src/modules/shared';

type AuthorSidebarContentProps = {
  trajectory: ITrajectoryDetail;
  pageId?: string;
  bookId: string;
  showTabs: boolean;
  sectionCode: TrajectorySectionCode;
};

export const AuthorSidebarContent: FC<AuthorSidebarContentProps> = ({
  trajectory,
  pageId,
  bookId,
  showTabs,
  sectionCode,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isSuperAdmin } = useUser();
  const filterTrajectoryOwner = false;

  const showNewPageManagment = useCallback(() => {
    if (isSuperAdmin) return true;
    if (!filterTrajectoryOwner) return true;
    return trajectory.isOwner;
  }, [isSuperAdmin, filterTrajectoryOwner, trajectory.isOwner]);

  const handlePublish = useCallback(() => {
    dispatch(
      setConfirmationTrajectory({
        id: trajectory.id,
        title: trajectory.title,
      })
    );
    dispatch(setOpenConfirmPublishDraft(true));
  }, [dispatch, trajectory]);

  const handleUnPublish = useCallback(() => {
    dispatch(
      setConfirmationTrajectory({
        id: trajectory.id,
        title: trajectory.title,
      })
    );
    dispatch(setOpenConfirmUnPublishDraft(true));
  }, [dispatch, trajectory]);

  const authorSideBarContentData = useMemo(() => {
    const content = [
      {
        title: 'Publicatie',
        data: (
          <TrajectoryPublishSidebar
            trajectory={trajectory}
            pageId={pageId}
            onPublish={handlePublish}
            onUnPublish={handleUnPublish}
          />
        ),
      },
      /*      {
        title: t('trajectory.sidebar.curriculumGoals.title'),
        data: <CurriculumGoalsSidebarContent />,
      }, */
    ];

    if (['0', '1', '4'].includes(sectionCode)) {
      content.splice(0, 0, {
        title: t('trajectory.sidebar.pageManagement.title'),
        data: (showNewPageManagment() && <PageManagementSidebarContentNew bookId={bookId} />) || (
          <PageManagementSidebarContent
            pageId={pageId}
            trajectory={trajectory}
            bookId={bookId}
            type={trajectorySectionCodeLookup[sectionCode as TrajectorySectionCode] as PageType}
          />
        ),
      });
    }

    return content;
  }, [
    sectionCode,
    t,
    trajectory,
    pageId,
    bookId,
    handlePublish,
    handleUnPublish,
    showNewPageManagment,
  ]);

  return (
    <TabbedContent
      ariaPrefix="trajectory-sidebar"
      hideTabs={!showTabs}
      content={authorSideBarContentData}
    />
  );
};
